import { createSlice } from '@reduxjs/toolkit';

const { reducer, actions } = createSlice({
    name: 'theme',
    initialState: {
        mode: localStorage.getItem('themeMode') || 'dark',
    },
    reducers: {
        toggleTheme: (state) => {
            const newMode = state.mode === 'dark' ? 'light' : 'dark';
            state.mode = newMode;
            localStorage.setItem('themeMode', newMode);
        },
    }
});

export const { toggleTheme } = actions;
export const themeReducer = reducer;
